import { useTranslation } from 'react-i18next';

const useRecurringType = () => {
  const { t } = useTranslation('translation');

  const types = {
    DAILY: t('donations.recurring-type.DAILY'),
    WEEKLY: t('donations.recurring-type.WEEKLY'),
    'BI-WEEKLY': t('donations.recurring-type.BI-WEEKLY'),
    MONTHLY: t('donations.recurring-type.MONTHLY'),
    YEARLY: t('donations.recurring-type.YEARLY'),
    UNLIMITED: t('donations.recurring-type.UNLIMITED'),
    'NOT-RECURRING': t('donations.recurring-type.NOT-RECURRING'),
  };

  const getType = (key) => {
    return types[key];
  };

  return { getType };
};

export default useRecurringType;
